import root from 'react-shadow';
import { useParams } from 'react-router';
import { i18n } from 'app/utils/i18n';
import { useCss } from 'app/api/style-queries';
import {
  AreaContent,
  HIGHLIGHT_CSS,
  PREVIEW_FLOW_CSS,
  SAMPLE_FOOTER,
  SAMPLE_HEADER,
  SAMPLE_HEADINGS,
  PREVIEW_CHROME_CSS,
  renderArea,
  renderPreviewSection,
  renderSampleBody,
  renderSampleLists,
  renderSampleTable,
  renderToc,
} from './preview-markup';

interface ThemePreviewProps {
  withTheme?: string;
}

export function ThemePreview({ withTheme }: ThemePreviewProps) {
  const { documentId } = useParams<{ documentId: string }>();
  const css = useCss({
    documentSuperId: documentId,
    documentRevisionId: undefined,
    useDraft: !withTheme,
    withStyle: undefined,
    withTheme,
    embedd: undefined,
    baseline: 'default',
    keepPreviousData: true,
  });

  if (css.isLoading || !css.data) {
    return (
      <div
        className="theme-preview text-muted fs-7 d-flex align-items-center justify-content-center"
        style={{ minHeight: 320, border: '1px dashed #dee2e6', borderRadius: 4 }}
      >
        {i18n('common.loading')}
      </div>
    );
  }

  const areaContent: AreaContent = {};

  return (
    <div className="theme-preview" style={{ flex: '1 1 auto', overflowY: 'auto', minWidth: 0, minHeight: 0 }}>
      <root.div>
        <style>{css.data.shadowedCss}</style>
        <style>{HIGHLIGHT_CSS}</style>
        <style>{PREVIEW_FLOW_CSS}</style>
        <style>{PREVIEW_CHROME_CSS}</style>
        <div className="theme-preview-page">
          {renderPreviewSection('dc.preview.section-header', renderArea('header', SAMPLE_HEADER, areaContent, ''))}
          {renderPreviewSection('dc.preview.section-toc', renderToc(SAMPLE_HEADINGS, true))}
          {renderPreviewSection('dc.preview.section-body', renderSampleBody())}
          {renderPreviewSection('dc.preview.section-table', renderSampleTable())}
          {renderPreviewSection('dc.preview.section-list', renderSampleLists())}
          {renderPreviewSection('dc.preview.section-footer', renderArea('footer', SAMPLE_FOOTER, areaContent, ''))}
        </div>
      </root.div>
    </div>
  );
}
